export enum Flags {
  JOB_POSTINGS_PAGE_LIMIT = 'job-postings-page-limit',
  ALLOW_WHATSAPP_ON_COLD_OUTREACH = 'allow-whatsapp-on-cold-outreach-v2',
  VIRTUAL_CALENDAR_USERS = 'virtual-calendar-users',
  ATS_SCOPE_RECONNECT = 'ats-scope-reconnect',
  EXTERNAL_ID_IS_MANDATORY = 'external-id-is-mandatory',
  CAMPAIGN_CREATION_V3 = 'campaign-creation-v3',
  EDIT_EXTERNAL_ID = 'edit-external-id',
  DEFAULT_LOCK_UPDATE_STATUS = 'default-lock-update-candidate-status',
  SOURCING_CHANNEL_SELECTION = 'sourcing-channel-selection',
  INTERNAL_SOURCING_CREATION = 'internal-sourcing-creation',
  CAMPAIGN_CANDIDATE_PRIORITISATION = 'campaign-candidate-prioritisation',
  WORKFLOW_BUILDER = 'workflow-builder',
  SOURCING_EXPLANATIONS = 'sourcing-explanations',
  USE_KOMBO_CONNECT = 'use-kombo-connect',
  HTML_EMAIL_FOOTER = 'html-email-footer',
  DOCUMENT_TYPES = 'document-types',
  // Both default ON in PostHog. Turn OFF per account to hide the control.
  CAMPAIGN_EMAIL_FALLBACK_TOGGLE = 'campaign-email-fallback-toggle',
  CAMPAIGN_ANALYSIS_SKIP_BUTTON = 'campaign-analysis-skip-button',
  // Default OFF. Turn ON per organisation to hide the element.
  HIDE_HOME_TAB = 'hide-home-tab',
  HIDE_CAMPAIGNS_TAB = 'hide-campaigns-tab',
  HIDE_ANALYSE_TAB = 'hide-analyse-tab',
  HIDE_SIGN_OUT_CONTROL = 'hide-sign-out-control',
  HIDE_INVITE_TO_APPLY = 'hide-invite-to-apply',
  HIDE_CLASSIC_MEETING_TEMPLATES = 'hide-classic-meeting-templates',
  // Default OFF. Turn ON per organisation to show talent list teams, and to
  // limit a list to one team.
  TALENT_LIST_TEAMS = 'talent-list-teams',
  TALENT_LIST_SINGLE_TEAM = 'talent-list-single-team',
  // Makes the Conversations tab the default landing view. Default OFF.
  CROSS_CAMPAIGN_CONVERSATIONS_TAB = 'cross-campaign-conversations-tab'
}
